import AddIcon from '@material-ui/icons/Add'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import CancelIcon from '@material-ui/icons/Cancel'
import InputAdornment from '@material-ui/core/InputAdornment'
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid'

import { Colors } from '~/styles'
import { Button, Input } from '~/components'
import {
  customHooks,
  ConvertLocalTimeGet,
} from '~/utils'

import SC from './styled.delay'
import Funcs from './functions.delay'


const DurationInput = ({ form }) => (
  <SC.DurationInputContainer>
    <SC.DurationLabel>Delay Duration</SC.DurationLabel>
    <SC.DurationInputWrapper>
      <Input
        id='exe-exct_mdl-act_berth_dura-hour-txt'
        style={{ marginBottom: 10 }}
        form={form}
        type='number'
        name='delay_dur_hour'
        placeholder='Hour'
        InputProps={{
          readOnly: true,
          endAdornment: <InputAdornment position='end'>Hour(s)</InputAdornment>,
        }}
        onChange={form.handleChange}
      />
      <Input
        id='exe-exct_mdl-act_berth_dura-minute-txt'
        form={form}
        style={{ marginBottom: 10 }}
        type='number'
        name='delay_dur_minute'
        placeholder='Minute'
        InputProps={{
          readOnly: true,
          endAdornment: <InputAdornment position='end'>Minute(s)</InputAdornment>,
        }}
        onChange={form.handleChange}
      />
    </SC.DurationInputWrapper>
  </SC.DurationInputContainer>
)

const TopRowForm = ({
  form,
  taskList,
  inEditMode,
  activityList,
  delayTypeOptions
}) => (
  <SC.RowWrapper>
    <SC.SelectFieldDelay
      form={form}
      tabIndex={1}
      isOptionsNotOrdered
      readOnly={!inEditMode}
      label='List Activity'
      optionValueKey='code'
      options={activityList}
      name='activity_code'
      optionText='activity_name'
      id='exct-mdl-delay-activity-name-select'
    />
    <SC.SelectFieldDelay
      form={form}
      tabIndex={2}
      label='List Task'
      optionText='task'
      options={taskList}
      optionValueKey='code'
      readOnly={!inEditMode}
      name='task_header_code'
      id='exct-mdl-delay-task-name-select'
    />
    <SC.SelectFieldDelay
      form={form}
      tabIndex={3}
      label='Delay Type'
      name='delay_type_code'
      readOnly={!inEditMode}
      options={delayTypeOptions}
      optionText='delay_type'
      optionValueKey='code'
      id='exct-mdl-delay-delay-type-select'
    />
  </SC.RowWrapper>
)

const MiddleRowForm = ({ form, delayDescOptions, inEditMode }) => (
  <SC.RowWrapper>
    <SC.SelectFieldDelay
      form={form}
      tabIndex={4}
      name='delay_code'
      readOnly={!inEditMode}
      label='Delay Description'
      options={delayDescOptions}
      optionValueKey='delay_code'
      optionText='delay_description'
      id='exct-mdl-delay-delay-description-select'
    />
    <SC.InputDateDelay
      form={form}
      tabIndex={5}
      name='start_date'
      label='Start Date'
      readOnly={!inEditMode}
      id='exct-mdl-delay-start-date-calendar'
    />

    <SC.InputDateDelay
      form={form}
      tabIndex={6}
      name='finish_date'
      label='Finish Date'
      readOnly={!inEditMode}
      id='exct-mdl-delay-finish-date-calendar'
    />
  </SC.RowWrapper>
)


const BottomRowForm = ({ form, inEditMode }) => (
  <SC.RowWrapper>
    <DurationInput form={form} />
    <Input
      form={form}
      rowsMax={5}
      name='remarks'
      label='Remarks'
      multiline={true}
      variant='outlined'
      style={{ width: '100%' }}
      value={form.values.remarks}
      id='exct-mdl-delay-remarks-txt'
      inputProps={{
        tabIndex: 7,
        readOnly: !inEditMode,
      }}
    />
  </SC.RowWrapper>
)

const CustomButton = ({ isInEdit, handleInsertOrUpdateDelay }) => {
  const handleClick = customHooks.usePreventMultipleClicks(handleInsertOrUpdateDelay)

  return (
    <Button
      type='submit'
      color={Colors.softGreen}
      id='mdl_dialog_save_delay_btn'
      style={{ width: '40px', marginLeft: '220px', marginTop: '10px' }}
      onClick={handleClick}
    >
      <AddIcon />
      {isInEdit ? 'Save' : 'Add'}
    </Button>
  )
}

const DelayForm = ({
  form,
  taskList,
  isInEdit,
  inEditMode,
  activityList,
  delayTypeOptions,
  delayDescOptions,
  handleInsertOrUpdateDelay,
}) => {
  return (
    <SC.FormContainerDelay>
      <TopRowForm
        form={form}
        taskList={taskList}
        inEditMode={inEditMode}
        activityList={activityList}
        delayTypeOptions={delayTypeOptions}
      />
      <MiddleRowForm
        form={form}
        inEditMode={inEditMode}
        delayDescOptions={delayDescOptions}
      />
      <BottomRowForm form={form} inEditMode={inEditMode} />
      {inEditMode && (
        <SC.ButtonContainer>
          <CustomButton
            isInEdit={isInEdit}
            handleInsertOrUpdateDelay={handleInsertOrUpdateDelay}
          />
        </SC.ButtonContainer>
      )}
    </SC.FormContainerDelay>
  )
}

const ActionCell = ({ dataItem, colSpan, handleDeleteDelay, handleToggleEdit, handleToggleCancel }) => {
  return (
    <td>
      { !dataItem?.isInEdit ?
        <SC.RowIcon colSpan={colSpan}>
          <SC.ActionCellWrapper
            id='m-edit-btn'
            onClick={() => handleToggleEdit(dataItem)}
          >
            <EditIcon style={{ color: Colors.softGreen }} />
          </SC.ActionCellWrapper>
          <SC.ActionCellWrapper
            id='m-delete-btn'
            onClick={() => handleDeleteDelay(dataItem)}
          >
            <DeleteIcon style={{ color: Colors.red }} />
          </SC.ActionCellWrapper>
        </SC.RowIcon>
        :
        <SC.RowIcon colSpan={colSpan}>
          <SC.ActionCellWrapper
            id='m-cancel-btn'
            onClick={() => handleToggleCancel(dataItem)}
          >
            <CancelIcon style={{ color: Colors.red }} />
          </SC.ActionCellWrapper>
        </SC.RowIcon>
      }
    </td>
  )
}

const ActivityNameCell = ({ dataItem }) => {
  return (
    <td style={{ textAlign: 'center', overflowWrap: 'anywhere' }}>
      {dataItem['activity_name']} - {dataItem['task']}
    </td>
  )
}

const DurationCell = ({ dataItem }) => {
  return (
    <td style={{ textAlign: 'center', overflowWrap: 'anywhere' }}>
      {Funcs.durationToFormattedString(dataItem['delay_duration'])}
    </td>
  )
}

const DatetimeCell = ({ dataItem, field, location }) => {
  return (
    <td style={{ textAlign: 'center', overflowWrap: 'anywhere' }}>
      {ConvertLocalTimeGet(location, dataItem[field], 'DD-MM-YYYY HH:mm')}
    </td>
  )
}

const DelayGrid = ({
  data,
  columns,
  location,
  gridHeight,
  inEditMode,
  handleToggleEdit,
  handleDeleteDelay,
  handleToggleCancel,
}) => {
  return (
    <SC.DelayGridWrapper marginTop={inEditMode ? 115 : 70}>
      <Grid
        data={data}
        id='exe-delay_mdl-all-data'
        style={{ height: gridHeight }}
      >
        {columns.map((e, index) => {
          if (e.field === 'action') {
            return (
              <Column
                key={index}
                width={e.width}
                title={e.title}
                field={e.field}
                cell={(props) => (
                  <ActionCell
                    {...props}
                    handleToggleEdit={handleToggleEdit}
                    handleToggleCancel={handleToggleCancel}
                    handleDeleteDelay={handleDeleteDelay}
                  />
                )}
              />
            )
          }

          if (e.field === 'activity_name') {
            return (
              <Column
                key={index}
                title={e.title}
                field={e.field}
                width={e.width}
                cell={(props) => <ActivityNameCell {...props} />}
              />
            )
          }

          if (e.field === 'delay_duration') {
            return (
              <Column
                key={index}
                title={e.title}
                field={e.field}
                width={e.width}
                cell={(props) => <DurationCell {...props} />}
              />
            )
          }

          if (e.field === 'start_date' || e.field === 'finish_date') {
            return (
              <Column
                key={index}
                title={e.title}
                field={e.field}
                width={e.width}
                cell={(props) => <DatetimeCell {...props} location={location} />}
              />
            )
          }

          return (
            <Column key={index} title={e.title} field={e.field} width={e.width} />
          )
        })}
      </Grid>
    </SC.DelayGridWrapper>
  )
}

export default {
  DelayForm,
  DelayGrid,
}